import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const sendNotificationSlice = createSlice({
  name: "sendNotification",
  initialState,
  reducers: {
    sendNotificationRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    sendNotificationRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    sendNotificationRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  sendNotificationRequest,
  sendNotificationRequestSuccess,
  sendNotificationRequestError,
} = sendNotificationSlice.actions;

export default sendNotificationSlice.reducer;
